import { Inject, Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { BOOX_STORAGE, BooxStorageToken } from '../token/boox-storage.token';


@Injectable({
  providedIn: 'root'
})
export class BooxStorageService {

  private _localStorage = window.localStorage;

  constructor(
    @Inject(BOOX_STORAGE) private storage_setting: BooxStorageToken
  ) { }

  private buildKey (_key : string) {
    return [this.storage_setting.domain, _key].filter(Boolean).join('.');
  }


  /**
   * 
   * @param _key 
   * @param _value 
   * @returns 
   */
  public setItem(_key : string, _value : any) {
    var value = JSON.stringify(_value);
    var phrase = CryptoJS.AES.encrypt(value, this.storage_setting.salt);
    this._localStorage.setItem(this.buildKey(_key), phrase.toString());
    return true;
  }

  /**
   * 
   * @param _key 
   * @returns 
   */
  public getItem(_key: string, _fallback : any = null) {
    try {
      var value = this._localStorage.getItem(this.buildKey(_key)) || null;
      if(value === null) {
        return _fallback;
      }
      value = CryptoJS.AES.decrypt(value, this.storage_setting.salt).toString(CryptoJS.enc.Utf8);
      value = JSON.parse(<string>value);
      return value;
      
    } catch (e) {
      return _fallback;
    }
  }

  /**
   * 
   * @param _key 
   */
  public clearItem (_key : string){
    this._localStorage.removeItem(this.buildKey(_key));
  }

  /**
   * 
   */
  public clear() {
    this._localStorage.clear();
  }
}
